export const getToggleTarget = function (toggleButton) {
  return document.querySelector('#' + toggleButton.getAttribute('aria-controls'))
}

export const setHeightStyle = function (target, height) {
  target.style.height = height
}

export const setDisplayStyle = function (target, display) {
  target.style.display = display
}

export const initToggleContent = function () {
  const toggleButtons = document.querySelectorAll('[data-js-toggle-content]')

  toggleButtons.forEach(function (toggleButton) {
    const buttonTextDefault = toggleButton.querySelector('span').innerText

    toggleButton.addEventListener('click', function () {
      const that = this
      const buttonTextExpanded = toggleButton.getAttribute('data-js-toggle-text')
      const target = getToggleTarget(that)
      const buttonText = that.querySelector('span')
      const icon = that.querySelector('img')

      icon.classList.toggle('icon-rotate-180')

      if (target) {
        slideToggle(target)
      }

      function slideToggle (container) {
        const active = container.style.height !== '' && container.style.height !== '0px'
        const actualHeight = container.clientHeight + 'px'

        if (active) {
          setTimeout(() => {
            setHeightStyle(container, '0px')
          }, 0)

          setHeightStyle(container, actualHeight)

          container.addEventListener('transitionend', () => {
            setDisplayStyle(container, 'none')
          }, { once: true })
          return
        }

        setDisplayStyle(container, 'flex')
        setHeightStyle(container, 'auto')
        const updatedHeight = container.clientHeight + 'px'

        setHeightStyle(container, '0px')

        setTimeout(() => {
          setHeightStyle(container, updatedHeight)
        }, 0)

        container.addEventListener('transitionend', () => {
          setHeightStyle(container, 'auto')
        }, { once: true })
      }

      if (buttonTextDefault === buttonText.innerText) {
        buttonText.innerText = buttonTextExpanded
      } else {
        buttonText.innerText = buttonTextDefault
      }
    }, false)
  })
}
